export const filterList = (list: any[], searchTerm: string): any[] => {
    if (!searchTerm) return list
    return list.filter((item: any) => {
        return item.name.toLowerCase().includes(searchTerm.toLowerCase())
    })
}
export const sortAlphabetically = (list: any[], accessor: string): any[] => {
    return list.sort((a, b) => {
        if (a[accessor] < b[accessor]) {
            return -1
        }
        if (a[accessor] > b[accessor]) {
            return 1
        }
        // a must be equal to b
        return 0
    })
}

// performs a merge of objects, but adds together values that share the same keys
export const mergeObjectsIncremental = (...args: { [key: string]: number }[]): { [key: string]: number } => {

    // create a new object
    let target = {} as { [key: string]: number };

    // merge the object into the target object
    const merger = (obj: { [key: string]: number }) => {
        for (let prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                target[prop] = (target[prop] || 0) + obj[prop];
            }
        }
    };

    // iterate through all objects and 
    // merge them with target
    for (let i = 0; i < args.length; i++) {
        merger(args[i]);
    }

    return target;
};